export default __webpack_public_path__ + "static/icon-22-3-54aad331b865c481526b600fb00482e3.png";